import { useSearchParams } from "@src/appV2/lib/utils/useSearchParams";

type InterviewAttendanceSource = "push-notification" | "auto-popup";

export function useInterviewAttendanceSource(): InterviewAttendanceSource | undefined {
  const { source } = useSearchParams();
  if (source === "push-notification" || source === "auto-popup") {
    return source;
  }

  return undefined;
}
